const CURRENCIES = {
  // TODO: plurialization long if it will use
  EUR: { symbol: '€', long: 'Euro', abbr: 'EUR' },
  USD: { symbol: '$', long: 'Dollar', abbr: 'USD' },
  GBP: { symbol: '£', long: 'Livre', abbr: 'GBP' },
  CHF: { symbol: 'CHF', long: 'Franc suisse', abbr: 'CHF' },
  AUD: { symbol: 'A$', long: 'Dollar australien', abbr: 'AUD' },
  CAD: { symbol: 'C$', long: 'Dollar canadien', abbr: 'CAD' },
  DKK: { symbol: 'kr', long: 'Couronne danoise', abbr: 'DKK' },
  NOK: { symbol: 'kr', long: 'Couronne norvégienne', abbr: 'NOK' },
  SEK: { symbol: 'kr', long: 'Couronne suédoise', abbr: 'SEK' },
  JPY: { symbol: '¥', long: 'Yen', abbr: 'JPY' },
  NZD: { symbol: 'NZ$', long: 'Dollar néo-zélandais', abbr: 'NZD' },
  SGD: { symbol: 'S$', long: 'Dollar de Singapour', abbr: 'SGD' },
  MXN: { symbol: 'Mex$', long: 'Peso mexicain', abbr: 'MXN' },
  HKD: { symbol: 'HK$', long: 'Dollar de Hong Kong', abbr: 'HKD' },
  BRL: { symbol: 'R$', long: 'Real brésilien', abbr: 'BRL' },
  MYR: { symbol: 'RM', long: 'Ringgit malaisien', abbr: 'MYR' },
  INR: { symbol: '₹', long: 'Roupie indienne', abbr: 'INR' },
  PLN: { symbol: 'zł', long: 'Złoty polonais', abbr: 'PLN' },
  CZK: { symbol: 'Kč', long: 'Couronne tchèque', abbr: 'CZK' },
  HUF: { symbol: 'Ft', long: 'Forint hongrois', abbr: 'HUF' },
  ILS: { symbol: '₪', long: 'Shekel israélien', abbr: 'ILS' },
  PHP: { symbol: '₱', long: 'Peso philippin', abbr: 'PHP' },
  TWD: { symbol: 'NT$', long: 'Dollar taïwanais', abbr: 'TWD' },
  THB: { symbol: '฿', long: 'Baht thaïlandais', abbr: 'THB' },
  TRY: { symbol: '₺', long: 'Lire turque', abbr: 'TRY' },
  AED: { symbol: 'د.إ', long: 'Dirham des Émirats arabes unis', abbr: 'AED' },
  SAR: { symbol: '﷼', long: 'Riyal saoudien', abbr: 'SAR' },
  ZAR: { symbol: 'R', long: 'Rand sud-africain', abbr: 'ZAR' },
  ARS: { symbol: '$AR', long: 'Peso argentin', abbr: 'ARS' },
  BOB: { symbol: 'Bs', long: 'Boliviano', abbr: 'BOB' },
  BGN: { symbol: 'лв', long: 'Lev bulgare', abbr: 'BGN' },
  CLP: { symbol: '$CL', long: 'Peso chilien', abbr: 'CLP' },
  COP: { symbol: '$CO', long: 'Peso colombien', abbr: 'COP' },
  CRC: { symbol: '₡', long: 'Colón costaricien', abbr: 'CRC' },
  EGP: { symbol: '£E', long: 'Livre égyptienne', abbr: 'EGP' },
  IDR: { symbol: 'Rp', long: 'Roupie indonésienne', abbr: 'IDR' },
  PYG: { symbol: '₲', long: 'Guarani paraguayen', abbr: 'PYG' },
  PEN: { symbol: 'S/', long: 'Sol péruvien', abbr: 'PEN' },
  RON: { symbol: 'lei', long: 'Leu roumain', abbr: 'RON' },
  UYU: { symbol: '$U', long: 'Peso uruguayen', abbr: 'UYU' }
}

export default CURRENCIES
